<div class="multi-select-container">
  <div class="multi-select-header">
    <div class="multi-select-label">
      {{title}}
    </div>

    <div id="filterStaff">
      <input type="text" class="form-control" placeholder="{{ placeholdertext }}" [ngModel]="filterBy" (ngModelChange)="filterItems($event)" />
    </div>
  </div>

  <div class="selector-container">
    <div class="selector-listbox">
      <select multiple class="selector-listbox-select">
        <option *ngFor="let value of this.getListValues(this.selectableItems);"
                (click)="moveSelected(value, 'right')"
                [value]="value">
          {{ value }}
        </option>
      </select>
    </div>
    <div class="selector-buttons">
      <input type="button" value=">>" (click)="moveAll('right')" />
      <input type="button" value="<<" (click)="moveAll('left')" />
    </div>
    <div class="selector-listbox">
      <select multiple class="selector-listbox-select">
        <option *ngFor="let value of this.getListValues(this.selectedItems);"
                (click)="moveSelected(value, 'left')"
                [value]="value">
          {{ value }}
        </option>
      </select>
    </div>
  </div>
</div>
